<template lang="pug">
	.persistent-schedule-list.tb-padding.flex-col.space-large
		ListView.full-width(ref="listView", initialView="table", :searchVisible="false", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadData", :columns="columns")
			template(v-slot:nameTemplate="{ data }")
				a(@click="openSchedule(data)") {{ data.Name || $tCaption('Schedule') }}
		Loader(v-if="isLoading", :fullscreen="true", text="")
</template>

<script>

import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import { 
	PERSISTENT_SCHEDULE_RUN_STATUS, PERSISTENT_SCHEDULE_JOB_TYPE 
} from 'app-core/constants';
import Loader from 'app-core/Loader';

export default {
	translationCategory: 'persistent-schedule.List',
	components: { ListView, DxButton, Loader },
	data() {
		let runStatuses = PERSISTENT_SCHEDULE_RUN_STATUS.toLocale('name', this);
		let jobTypes = PERSISTENT_SCHEDULE_JOB_TYPE.toLocale('name', this)
		return {
			runStatuses,
			columns: [
                { dataField: 'Name', caption: () => this.$tCaption('Name'), cellTemplate: 'nameTemplate' },
                { dataField: 'Expire', caption: () => this.$tCaption('Expires') },
				{ dataField: 'RunStatus', caption: () => this.$tCaption('RunStatus'), lookup: {
					dataSource: runStatuses,
					displayExpr: 'name',
					valueExpr: 'id'
				}},
				{ dataField: 'JobType', caption: () => this.$tCaption('Job type'), lookup: {
					dataSource: jobTypes,
					displayExpr: 'name',
					valueExpr: 'id'
				}},
            ],
			isLoading: false
		};
	},
	computed: {

	},
	mounted() {
		if (__DEBUG__)
			window.persistentScheduleList = this;
	},
	destroyed() {
		
	},
	methods: {
		loadData(pageIndex, limit, opts) {
			if (opts && opts.byKey)
				return this.$Data.getExternalApi('PersistentSchedule/Get', `id=${opts.byKey}`).then(r => ({ Results: r }));
			return this.$Data.getExternalApi('PersistentSchedule/List', `page=${pageIndex + 1}${this.$Data.getFilterCriteriaSortingParams(opts)}`, limit);
		},
		openSchedule(schedule) {
			this.$router.push({ path: `/persistent-schedule/Detail/${schedule.Oid}`});
		}
	}
};
</script>
<style lang="scss">
	.persistent-schedule-list {
		
	}
</style>
